import { InvoiceInterface } from "./invoice.interface";
import { Receipt } from "./receipt.interface";

interface Transaction {
  transaction: { date: any; };
  date: Date | string;
  amount: number;
  vat: number;
  description: string;
  salesamount?: number;
  customer?: string;
  additional?: any;
  category?: string;
  preset?: string | null;
  subcategory?: string;
  atocategory?: string;
  expenseDirection: string;
  status?: string;
  source: TransactionSource;
  ignore: boolean;
  internal: boolean;
  proof: proof[];
  receipts?: Receipt[],
  sorted: boolean;
  note: string;
  revenueChannel?: RevenueChannel;

  squareTransactions: SquareTransaction[];
  ebayPayouts: EbayPayouts[],
  cashDeposit: CashTransaction[],

  // For MSP accounts where the business has paid into the revenue account.
  mspCountAsAContribution: boolean;

  invoice?: InvoiceInterface;
  supplier: {
    business: string;
    date: string;
    order: string;
  };
}

interface proof {
  dateAdded: Date
  fileName: string;
  location: string;
  sha1: string;
  valid: boolean;
}

interface RevenueChannel {
  sales?: boolean,
  retail?: boolean,
  msp?: boolean,
  ebay?: boolean,
  outcall?: boolean
}

interface TransactionSource {
  account: string;
  original: any;
  sha1: string;
}

enum TransactionStatus {
  proven,
  internal,
  unknown,
  ignore,
  waiting
}

interface CashTransaction {
  invoice: string,
  amount: number
}

interface SquareTransaction {
  date: string;
  time: string;
  timeZone: string;
  totalCollected: number;
  fees: number;
  netTotal: number;
  note: string;
  transactionID: string;
  paymentID: string;
  cardBrand: string;
  deviceName: string;
  squareURL: string;
  location: string;
  transactionStatus: string;
  refund: boolean;
}

interface EbayPayouts {
  type: string,
  order: string,
  invoice?: number,
  customer: {
    buyerUsername: string;
    buyerName: string;
    deliverycity: string;
    deliveryProvince: string;
    deliveryPostcode: string;
    deliveryCountry: string;
  };
  payout: {
    payoutDate: string;
    payoutID: string;
    payoutmethod: string;
    payoutStatus: string;
    reasonForHold: string;
    transactionID: string;
  };
  item: { 
    itemID: string;
    itemTitle: string;
    itemSubtotal: string;
    quantity: string;
  };
  feesBreakdown: {
    finalValueFeeFixed: string;
    finalValueFeeVariable: string;
    veryHighItemNotAsDescribedFee: string;
    belowStandardPerformanceFee: string;
  },
  fees: number,
  amount: number,
  refund?: number,
  raw: any
}

interface DateRange {
  start: Date;
  end: Date;
}

interface Transfer {
    srcAccount: string,
    destAccount: string,
    amount: number,
    transactionDescription: string,
    isExternal?: boolean
    name?: string;
}

enum TransactionType {
  Expense,
  Revenue
}

const COGS = [
  {label: "Cost of Services", value: "cost-of-services" },
  {label: "Cost of Goods", value: "cost-of-goods" },
  {label: "Software Subscription", value: "software-subscription" },
  {label: "Postage", value: "delivery-and-postage" },
  {label: "Subcontractor", value: "subcontractor" },
  {label: "Commodity Purchase", value: "commodity-purchase" },
  {label: "Refund", value: "refund" },
];

const OperatingExpenses = [
  { label: "Supplies", value: "supplies" },
  { label: "Merchant Fees", value: "merchant-fees" },
  { label: "Rent", value: "rent" },
  { label: "Insurance", value: "insurance" },
  { label: "Business Subscriptions", value: "subscriptions" },
  { label: "Bank Fees and Charges", value: "bank-fees-and-charges" },
  { label: "Telephone", value: "telephone" },
  { label: "Internet", value: "internet" },
  { label: "Utilites", value: "utilities" },
  { label: "Advertising and Promotion", value: "advertising-and-promotion" },
  { label: "Uniforms", value: "protective-clothing" },
  { label: "Rubbish", value: "rubbish-waste" },
  { label: "Printing and Stationary", value: "printing-and-stationary" },
  { label: "Shop Fitment", value: "shop-fitment" },
  { label: "Professional Service", value: "professional-service" },
  { label: "Tools", value: "tools" },
  { label: "Work Experience", value: "work-experience" },
  { label: "Travel", value: "travel" },
  { label: "ASIC & Government Fees", value: "asic-and-government-fees" },
  { label: "Cash shortage / Till Variance", value: "cash-shortage-till-variance" },
]

interface TransactionQuery {
  amount?: number;
  dateRange?: { start: Date; end: Date };
  account?: string;
}

export { Transaction, TransactionType, TransactionStatus, RevenueChannel, SquareTransaction, EbayPayouts, DateRange, COGS, OperatingExpenses, Transfer, TransactionQuery }
